import { ApiResponse, Doctor } from '../../types';
import apiClient from '../api/client';
import { delay } from '../mock/delay';
import { mockDoctors } from '../mock/doctors';

export const doctorService = {
  getList: async (): Promise<Doctor[]> => {
    try {
      const response = await apiClient.get<ApiResponse<Doctor[]>>('/doctors/');
      if (response.data.success) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },

  create: async (doctor: Doctor): Promise<Doctor> => {
    try {
      const response = await apiClient.post<ApiResponse<Doctor>>('/doctors/', doctor);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to create doctor');
      }
    } catch (error) {
      throw new Error('Failed to create doctor');
    }
  },

  update: async (id: string, doctor: Partial<Doctor>): Promise<Doctor> => {
    try {
      const response = await apiClient.put<ApiResponse<Doctor>>(`/doctors/${id}/`, doctor);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to update doctor');
      }
    } catch (error) {
      throw new Error('Failed to update doctor');
    }
  },

  delete: async (id: string): Promise<void> => {
    try {
      await apiClient.delete<ApiResponse<void>>(`/doctors/${id}/`);
    } catch (error) {
      throw new Error('Failed to delete doctor');
    }
  },
};

